import { render, staticRenderFns } from "./CollaborativeTaskList.vue?vue&type=template&id=895dfb8e&scoped=true"
import script from "./CollaborativeTaskList.vue?vue&type=script&lang=js"
export * from "./CollaborativeTaskList.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeTaskList.vue?vue&type=style&index=0&id=895dfb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895dfb8e",
  null
  
)

export default component.exports